import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../../helpers/react.js";
import '../../../assets/index44.css';const body = "_body_1rbgo_1";
const s = {
  body
};
const Body = forwardRef(({ className, ...rest }, ref) => /* @__PURE__ */ jsx("div", { className: clsx(className, s.body), ref, ...rest }));
Body.displayName = "DrawerBody";
export {
  Body
};
